import { render, staticRenderFns } from "./memberManages.vue?vue&type=template&id=487a5a08&scoped=true"
import script from "./memberManages.vue?vue&type=script&lang=js"
export * from "./memberManages.vue?vue&type=script&lang=js"
import style0 from "./memberManages.vue?vue&type=style&index=0&id=487a5a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a5a08",
  null
  
)

export default component.exports